module.exports = __webpack_public_path__ + "img/get-directions.425df19a.png";